// Pure validation / normalization helpers used by feature forms.
// Pure + unit-tested so the rules can't silently drift.

export type ParsedNumber = { ok: true; value: number | null } | { ok: false };

/**
 * Parse an optional numeric form field.
 *   ""        -> { ok: true, value: null }   (blank optional field)
 *   "12.5"    -> { ok: true, value: 12.5 }
 *   "abc"/NaN -> { ok: false }               (caller shows an error)
 * Guarantees a NaN/Infinity never reaches the database.
 */
export function parseOptionalNumber(raw: string): ParsedNumber {
  const t = raw.trim();
  if (t === "") return { ok: true, value: null };
  const n = Number(t);
  if (!Number.isFinite(n)) return { ok: false };
  return { ok: true, value: n };
}

/** Basic email shape check (UX-level; the real guard is whatever consumes it). */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}

/** Latitude domain: -90..90. */
export function isValidLatitude(n: number): boolean {
  return n >= -90 && n <= 90;
}

/** Longitude domain: -180..180. */
export function isValidLongitude(n: number): boolean {
  return n >= -180 && n <= 180;
}

/** A 24-hour "HH:MM" time string, e.g. "08:00" or "23:45". */
export function isValidTimeHHMM(value: string): boolean {
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(value.trim());
}
